import classNames from 'classnames'
import { CSSProperties, MouseEvent } from 'react'

import { Link } from '~/components/Link'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface ButtonProp {
  iconSrcKey: string
  title: string
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  className?: string
  style?: CSSProperties
  link?: string
  iconWrapClass?: string
  iconWidth?: number
  iconHeight?: number
  iconClassName?: string
}

const IconButton = ({
  iconSrcKey,
  title,
  onClick,
  className,
  style,
  link,
  iconWrapClass = '',
  iconWidth = 25,
  iconHeight = 25,
  iconClassName = '',
}: ButtonProp): React.ReactElement => {
  const iconContainerClass = classNames(
    'flex items-center px-1 py-2 rounded hover:bg-purple-light focus:bg-purple-light transition transition-color duration-300',
    className,
  )
  const mediaQuery = [{ screen: '(min-width: 280px)', width: `${iconWidth}px` }]
  const icon = (
    <div className={`mr-2 w-7 ${iconWrapClass}`}>
      <ResponsiveImage
        height={iconHeight}
        imageClassName={`mx-auto ${iconClassName}`}
        imageWidths={`${iconWidth}`}
        mediaQuery={mediaQuery}
        srcKey={iconSrcKey}
        width={iconWidth}
      />
    </div>
  )

  if (link) {
    return (
      <Link className={iconContainerClass} style={style} to={link}>
        {icon}
        <span>{title}</span>
      </Link>
    )
  }

  return (
    <button className={iconContainerClass} onClick={onClick} style={style}>
      {icon}
      <span>{title}</span>
    </button>
  )
}

IconButton.defaultProps = {
  className: '',
}

export default IconButton
